import { Modal } from 'react-bootstrap';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import LightGrayCross from "@/assets/icons/lightGrayCross.png";
import "./style.css"
import { themes } from '@/constants/colors_v2';
import { addCurrentThemeClassToEle } from '@/utils';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';

function EmptyModalWithBtns(props: any) {
    const { dashboard, common } = useLocalTranslation();
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    return (
        <Modal
            show={props.show}
            onHide={() => props.handleClose('close')} centered>
            <div className={`p-[20px] ${addCurrentThemeClassToEle(currentTheme, 'emptyModalIndex')}`}>

                <Modal.Header className='p-0 border-0 mb-[10px]'>


                    {currentTheme === themes.dark ? (
                        <div className='darkThemetopCloseButtonHelperModelCon'>
                            <Modal.Title className='text-[16px] font-semibold watchModel12Title'>
                                {props.title}
                            </Modal.Title>

                            <button
                                onClick={() => props.handleClose('close')}
                                type="button"
                                className='text-[14px]'
                                aria-label="Close">
                                <img src={LightGrayCross} alt='LightGrayCross' className='w-[14px]' />
                            </button>
                        </div>
                    ) : (
                        <>
                            <Modal.Title className='text-[16px] font-semibold watchModel12Title'>
                                {props.title}
                            </Modal.Title>

                            <button
                                onClick={() => props.handleClose('close')}
                                type="button"
                                className='btn-close topCloseButtonHelper'
                                aria-label="Close">
                            </button>

                        </>
                    )}


                    {/* <Modal.Title className='text-[16px] font-bold'>
                        {props.title}
                    </Modal.Title>
                    <button
                        onClick={() => props.handleClose('close')}
                        type="button"
                        className="btn-close text-[14px]" aria-label="Close"></button> */}


                </Modal.Header>

                <Modal.Body className='p-0'>
                    {props.body}
                </Modal.Body>


                <div className="text-[14px] flex justify-between mt-6 space-x-4">
                    <button
                        disabled={props.actionBtnLoading}
                        style={{
                            cursor: props.actionBtnLoading ? 'not-allowed' : 'pointer',
                            opacity: props.actionBtnLoading ? '0.4' : '1'
                        }}
                        className="watchModel12LeftBtn flex-1 font-medium py-2 rounded-md"
                        onClick={() => props.handleClose('ok')}
                    >
                        {props.btn1Text}
                    </button>
                    <button
                        className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 rounded-md"
                        onClick={() => props.handleClose('close')}
                    >
                        {props.btn2Text}
                    </button>
                </div>

            </div>
        </Modal>
    );
}

export default EmptyModalWithBtns;